module.exports = __webpack_public_path__ + "media/images/catalog-promo/promo496-95cfc7196aa14d536684aa73cddb45b3.jpg";